import { Box } from "@mui/material";
import defaultHeaderImage from "../../img/default_profile_banner.webp";

interface HeaderImgProps {
  userName?: string;
  headerImageUrl: string | undefined;
  profileImageUrl?: string;
  vip?: boolean;
}

export const HeaderImg = ({
  userName,
  headerImageUrl,
  profileImageUrl,
  vip,
}: HeaderImgProps) => {
  return (
    <Box className="profile-cover" sx={{ position: "relative" }}>
      <img
        src={headerImageUrl ? headerImageUrl : defaultHeaderImage}
        alt="cover-pic"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          maxHeight: "300px",
        }}
      />
    </Box>
  );
};

export default HeaderImg;
